import { render, staticRenderFns } from "./SearchPatientInput.vue?vue&type=template&id=3b825270&"
import script from "./SearchPatientInput.vue?vue&type=script&lang=js&"
export * from "./SearchPatientInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports